import React, { Fragment } from 'react';
import { FlexContainerRowInner } from '../../styled/skylab/page';
import FormInput from '../../../containers/shared/forms/form-input';
export const startFormFields = () => (React.createElement(Fragment, null,
    React.createElement(FlexContainerRowInner, null,
        React.createElement("fieldset", null,
            React.createElement("label", { htmlFor: 'firstName' }, "First Name"),
            React.createElement(FormInput, { fieldName: 'firstName' })),
        React.createElement("fieldset", null,
            React.createElement("label", { htmlFor: 'lastName' }, "Last Name"),
            React.createElement(FormInput, { fieldName: 'lastName' }))),
    React.createElement("fieldset", null,
        React.createElement("label", { htmlFor: 'email' }, "Email / Username"),
        React.createElement(FormInput, { type: 'email', fieldName: 'email', validateDuringInput: true })),
    React.createElement("fieldset", null,
        React.createElement("label", { htmlFor: 'phone' }, "Phone"),
        React.createElement(FormInput, { type: 'tel', fieldName: 'phone', maxLength: 15, validateDuringInput: true }))));
export default startFormFields;
